import {
  deleteAccessTokenAndUser,
  sendAuthEvent,
  sendAuthViewImp,
  showPAlertDifferentRegion,
  showPAlertTermsNotAgreed,
} from '../../../auth/common';
import {clearUserInfo, getCsMailUrl} from '../../../commonSub/function';
import {pAlert} from '../../component/PAlert';
import Text from '../../component/Text';
import {AppUri, DOMAIN_MAP, ENV_NAME, IS_CLIENT, REGION} from '../../constant';
import {Page} from '../../constant/page';
import {pToast} from '../../container/PToast';
import {showAuthModal} from '../../function';
import {actions as commonActions} from '../../state/action';
import {getClientStore} from '../../store';
import {IRegion} from '../../type';
import {ButtonSet} from '../../type/alert';
import {routeBack, routeTo, routeToApp} from '../PageRouter';
import {addOneTimeRouterObserver} from '../routerObserver';
import {toConstantCase} from '../string';
import {getIsWebView} from '../userAgent';

export type IProcessApiErrorCallback = (error: IApiError) => boolean;

export interface IApiError {
  code?: number;
  resultCode?: string;
  errorType: string;
  errorMessage?: string;
  notice?: {
    title: string;
    subTitle: string;
    content: string;
  };
}

// TODO: 필요에 맞춰서 수정, 정적으로 가능하면 이전처럼 map사용
export function needShowAlert(_error?: IApiError) {
  return false;
}

// 참고:
// - 회원 에러코드: https://podotree.atlassian.net/wiki/spaces/KW/pages/2093023634/StatusCode
export function processApiError({
  error,
  processApiErrorCallback,
}: {
  error?: IApiError;
  processApiErrorCallback?: IProcessApiErrorCallback;
}) {
  if (!error || processApiErrorCallback?.(error)) return;

  const errorType = toConstantCase(error.errorType);
  const errorMsg = error.errorMessage;
  switch (errorType) {
    case 'INTERNAL_SERVER_ERROR':
      pToast(t => t('error_server_popup_request'));
      break;
    case 'ACCESS_TOKEN_EXPIRED':
    case 'ACCESS_TOKEN_REVOKED':
    case 'ACCESS_TOKEN_NONCE_EXPIRED':
    case 'EMPTY_ACCESS_TOKEN':
      showAuthModal(
        getIsAdultViewer()
          ? {
              titleType: 'adult',
              pageInfoAfterClose: {page: Page.Home},
            }
          : undefined
      );
      break;
    case 'ACCESS_TOKEN_EVICTED':
      pAlert({
        title: t => t('login_forced_logout_popup'),
        groupId: errorType,
        isAliveWhenRouting: true,
      }).then(() => {
        getClientStore()?.dispatch(commonActions.setValue('isOnLogout', true));
        deleteAccessTokenAndUser();
        routeTo({page: Page.Home}, {isReplace: true});
      });
      break;
    case 'INVALID_ACCESS_TOKEN':
    case 'ACCESS_TOKEN_LOGOUT':
    case 'ACCESS_TOKEN_UNREGISTERED':
    case 'ACCESS_TOKEN_BLOCKED':
    case 'ACCESS_TOKEN_SECURITY_FAKED':
      deleteAccessTokenAndUser();
      break;
    case 'ID_VERIFICATION_ERROR':
      pToast(t => t('authentication_korea_failed_toast'));
      break;
    case 'ID_VERIFICATION_INVALID_GUARDIAN':
      pToast(t => t('authentication_korea_failed_under17_toast'));
      routeTo({page: Page.AuthTerms}, {isReplace: true});
      break;
    case 'DEVICE_DELETE_LIMIT':
      // TODO: '디바이스 등록 해체 횟수 초과'라고 하는데, 어디서 사용하는지 확인해보자.
      break;
    case 'DEVICE_REGISTER_LIMIT_CANT_REMOVE_DEVICE':
      // TODO: 국내 only
      break;
    case 'DEVICE_REGISTER_LIMIT_CAN_REMOVE_DEVICE':
      // TODO: 국내 only
      break;
    case 'INVALID_REGION':
      showPAlertDifferentRegion().then(okClicked => {
        const userRegion = errorMsg as IRegion;
        okClicked && location.assign(DOMAIN_MAP[userRegion][ENV_NAME]);
      });
      break;
    case 'INVALID_REQUIRED_TERMS_BIRTH_DATE':
      break;
    case 'DEVICE_LOGIN_LIMIT':
      sendAuthViewImp({
        customProps: {popup_type: 'login_unable'},
        viewImpContents: {name: 'popup'},
      });

      pAlert({
        groupId: CHECK_CLICK_CS,
        title: t => t('login_restricted_popup_title'),
        desc: t => (
          <>
            <Text className="s13-regular-grey08">
              {t('login_restricted_popup_content')}
            </Text>
            <Text
              className="s14-regular-white light:text-black flex mt-16"
              onClickLink={() =>
                sendAuthEvent({
                  actionName: 'popup_contact_us',
                  customProps: {
                    event_layer: 'popup',
                    popup_type: 'login_unable',
                  },
                })
              }
            >
              {t('login_restricted_help_popup')}
            </Text>
          </>
        ),
        isTextAlignCenter: false,
        isAliveWhenRouting: true,
      }).then(({isDimmedClicked}) => {
        sendAuthEvent({
          actionName: 'popup_ok',
          customProps: {
            event_layer: isDimmedClicked ? 'dimmed' : 'popup',
            popup_type: 'login_unable',
          },
        });
      });
      addOneTimeRouterObserver('routeChangeComplete', removeAlertWhenClickCs);
      break;
    case 'INVALID_NICKNAME_LENGTH':
      pToast(t => t('more_myinfo_nickname_length'));
      break;
    case 'UNSUPPORTED_NICKNAME_CHARACTER':
      pToast(t => t('more_myinfo_nickname_character'));
      break;
    case 'BLOCKED_USER':
      sendAuthViewImp({
        customProps: {popup_type: 'login_reject'},
      });
      pAlert({
        groupId: CHECK_CLICK_CS,
        title: t => t('blocked_user_popup_title'),
        desc: t => (
          <>
            <Text className="s13-regular-grey08">
              {t('blocked_user_popup_content')}
            </Text>
            <Text
              className="s14-regular-white light:text-black flex mt-16"
              onClickLink={() =>
                sendAuthEvent({
                  actionName: 'popup_contact_us',
                  customProps: {
                    event_layer: 'popup',
                    popup_type: 'login_reject',
                  },
                })
              }
            >
              {t('blocked_user_popup_content_cs')}
            </Text>
          </>
        ),
        isTextAlignCenter: false,
        isAliveWhenRouting: true,
      }).then(({isDimmedClicked}) => {
        sendAuthEvent({
          actionName: 'popup_close',
          customProps: {
            event_layer: isDimmedClicked ? 'dimmed' : 'popup',
            popup_type: 'login_reject',
          },
        });
      });
      addOneTimeRouterObserver('routeChangeComplete', removeAlertWhenClickCs);
      break;
    case 'UNREGISTERED_WITHIN_SEVEN_DAYS':
      sendAuthViewImp({
        customProps: {popup_type: 'signup_reject'},
        viewImpContents: {name: 'popup_signup_reject'},
      });
      pAlert({
        title: t => t('deleted_account_popup'),
        isAliveWhenRouting: true,
      }).then(({isDimmedClicked}) => {
        sendAuthEvent({
          actionName: 'popup_close',
          customProps: {
            event_layer: isDimmedClicked ? 'dimmed' : 'popup',
            popup_type: 'signup_reject',
          },
        });
      });
      break;
    case 'FORBIDDEN':
      IS_CLIENT && showPAlertTermsNotAgreed();
      !IS_CLIENT && clearUserInfo();
      break;
    case 'INVALID_TICKET_PACKAGE':
      pToast(t => t('error_server_popup_request'));
      break;
    case 'GIFTBOX_TICKET_ALREADY_RECEIVED':
    case 'CONTENT_HOME_GIFT_ALREADY_RECEIVED':
      pToast(t => t('gift_ticket_fail_received_popup'));
      break;
    case 'GIFTBOX_TICKET_NOT_AVAILABLE_PERIOD':
    case 'CONTENT_HOME_GIFT_NOT_AVAILABLE_PERIOD':
      pToast(t => t('gift_ticket_fail_expired_popup'));
      break;
    case 'COMMENT_CREATE_TOO_SHORT_REQUEST':
      pToast(t => t('comment_write_snackbar'));
      break;
    case 'COMMENT_REPORT_ALREADY_REPORT':
      pToast(t => t('comment_report_already_report'));
      break;
    case 'COMMENT_DELETED':
      pToast(t => t('comment_deleted_click_action_toast'));
      break;
    case 'COMMENT_NOT_FOUND':
      pToast(t => t('comment_deleted_toast'));
      break;
    case 'COMMENT_TEMPORARY_ACTION':
      pToast(t => t('comment_regulated_reply_error'));
      break;
    case 'COMMENT_BLOCK_ALREADY_BLOCK':
      pToast(t => t('comment_already_blocked_toast'));
      break;
    case 'COMMENT_BLOCK_NOT_BLOCK':
      pToast(t => t('comment_already_unblocked_toast'));
      break;
    case 'NOT_NEW_USER':
      pToast(t => t('redeem_coupon_toast_fail_ineligible'));
      break;
    case 'SAME_TYPE_COUPON':
      pToast(t => t('redeem_coupon_toast_fail_sametype'));
      break;
    case 'ALREADY_USED_CODE':
      pToast(t => t('redeem_coupon_toast_fail_used'));
      break;
    case 'INVALID_COUPON':
      pToast(t => t('redeem_coupon_toast_fail_invalid_checkagain'));
      break;
    case 'COUPON_CODE_NOT_AVAILABLE_PERIOD':
      pToast(t => t('redeem_coupon_toast_fail_expired'));
      break;
    case 'NOT_ALLOWED':
      pToast(t => t('error_server_common_toast'));
      break;
    case 'PREPARED_QUANTITY_EXHAUSTED':
      pToast(t => t('redeem_coupon_toast_fail_ranout'));
      break;
    case 'NOT_AVAILABLE_EVENT':
    case 'NOT_AVAILABLE_LUCKY_DRAW':
    case 'EXPIRED_EVENT':
      IS_CLIENT &&
        pAlert({
          title: t =>
            t(
              errorType === 'EXPIRED_EVENT'
                ? 'error_event_expired_popup'
                : 'error_event_participate_popup'
            ),
          isForced: true,
        }).then(({okClicked}) => {
          okClicked && routeBack();
        });
      break;
    case 'UNDER_AGE_GRADE':
      pToast(t => t('login_adult_toast'));
      break;
    case 'DUPLICATE_DATA':
      pToast(t => t('login_blocked_toast'));
      break;
    case 'NOT_FOUND':
      IS_CLIENT &&
        pAlert({
          title: t => t('error_not_found'),
          labelConfirm: t => t('common_close'),
        }).then(({okClicked}) => {
          okClicked && routeBack();
        });
      break;
    case 'BAD_REQUEST':
      pToast(t => t('error_server_popup_request'));
      routeTo({page: Page.Home}, {isReplace: true});
      break;
    case 'NOT_ENOUGH_CASH_AMOUNT':
      pToast(t => t('ticket_purchase_shortage'));
      break;
    case 'OTHER_REGION_USER':
      pAlert({
        title: t => t('error_region_unmatch_web_popup'),
        labelConfirm: t => t('common_confirm'),
      }).then(() => {
        getClientStore()?.dispatch(commonActions.setValue('isOnLogout', true));
        deleteAccessTokenAndUser();
        routeTo({page: Page.Home}, {isReplace: true});
      });
      break;
    case 'DUPLICATE_REQUEST':
      pToast(t => t('error_server_duplicate_request_toast'));
      break;
    default:
      if (!IS_CLIENT) {
        throw new Error(`uncaught api error type(${errorType})`);
      }
      break;
  }
}

function getIsAdultViewer() {
  return !!(
    getClientStore()?.getState().viewer.episode?.ageLimit === 19 &&
    REGION === 'kor'
  );
}

function removeAlertWhenClickCs() {
  const store = getClientStore();
  if (store) {
    const {getState, dispatch} = store;
    const idx = getState().common.pAlerts.findIndex(
      alert => alert.groupId === CHECK_CLICK_CS
    );
    idx === 0 && dispatch(commonActions.removeAlert());
  }
}

export function processAuthBlockedUser(blockedAt: string) {
  pAlert({
    groupId: 'service_block_popup_title',
    title: t => t('service_block_popup_title'),
    desc: t => (
      <div>
        <Text className="s15-bold-black light:text-white">
          {t('service_block_popup_contents')}
        </Text>
        <Text className="s15-bold-black light:text-white">
          {t('service_block_popup_period', {value: blockedAt})}
        </Text>
      </div>
    ),
    isForced: true,
    buttonSet: ButtonSet.CancelAndConfirm,
    labelConfirm: t => t('service_block_popup_cs_email'),
  }).then(({okClicked}) => {
    // iOS에서는 location.assign이 두번 실행되면 첫번째가 무시된다.
    // 첫번째는 getCsMailUrl 함수, 두번째는 routeToApp 함수
    // 이유는 모르겠지만, 0.001초만 딜레이를 줘도 정상 동작한다 (iOS에서 확인)
    if (okClicked) {
      const state = getClientStore()?.getState();
      if (state) {
        location.assign(
          getCsMailUrl({
            userAgent: state.common.userAgent,
            user: state.auth.user,
          })
        );
      }
    }
    deleteAccessTokenAndUser();
    setTimeout(() => {
      if (getIsWebView()) {
        routeToApp(AppUri.Close);
      } else {
        routeTo({page: Page.Home});
      }
    }, 1);
  });
}

/**
 * errorType으로 에러 구분하도록 서버쪽에서 결정함 (code는 optional)
 * TODO: ApiResultCode와 errorType과 통합해야 할 것 같다. 작업 범위가 많을 것 같아, 논의 후 진행하자.
 */
export enum ApiResultCode {
  Success = 200,

  // 아래는 우리쪽에서 정의해서 사용하는 코드
  UnexpectedError = -2,
  Timeout = 408,
  ServiceMaintenance = 900,
}

const CHECK_CLICK_CS = 'check_click_cs';
